import 'regenerator-runtime/runtime';

import micromodal from 'micromodal';

import initThirdParties from './initThirdParties';
import initAnalytics from '../common/analytics';

export default function initPage() {
   initAnalytics();
   initThirdParties();
   initMicromodal();
}

function initMicromodal() {
   document.body.addEventListener('mousedown', (e) => close(e.target));
   document.body.addEventListener('touchstart', (e) => close(e.target));

   /** @param {HTMLElement} target */
   function close(target) {
      if (!target.hasAttribute('data-close-parent-modal')) return;
      const modal = target.closest('.modal');
      if (modal) micromodal.close(modal.id);
   }
}
